export enum TransportStatus {
    ToPlan = 0,
    Planned = 1,
    InTransit = 2,
    Completed = 3,
    Accepted = 4
}

export const TransportStatusOptions = [
    {
        label: "core.transport_status.to_plan",
        value: TransportStatus.ToPlan
    },
    {
        label: "core.transport_status.planned",
        value: TransportStatus.Planned
    },
    {
        label: "core.transport_status.accepted",
        value: TransportStatus.Accepted
    },
    {
        label: "core.transport_status.in_transit",
        value: TransportStatus.InTransit
    },
    {
        label: "core.transport_status.completed",
        value: TransportStatus.Completed
    }
]
